const features = [
  {
    icon: "code",
    title: "Circuit Workspace",
    description: "Define circuit code, inputs, and framework-specific files"
  },
  {
    icon: "gauge",
    title: "Benchmark Performance",
    description: "Run parallel benchmarks across curves, backends, and machines"
  },
  {
    icon: "rocket",
    title: "Deployments",
    description: "Deploy provers or verifiers on our machines or yours"
  },
  {
    icon: "folder-tree",
    title: "Artifact",
    description: "Version control for your circuits, proving and verification keys"
  },
  {
    icon: "line-chart",
    title: "Observability",
    description: "Track job status, monitor deployments, and resource usage"
  },
  {
    icon: "users",
    title: "Team Collaboration",
    description: "Access circuits and benchmark results within your organization"
  }
];

export function Features() {
  return (
    <section className="section has-background-white py-5">
      <div className="container mx-auto px-2 mt-6 is-max-widescreen">
        <div className="has-text-centered mb-6">
            <h2 className="mb-2">Everything you need for ZK development</h2>
            <p className="is-size-5  has-text-text-60 mx-auto" style={{maxWidth: "48rem"}}>
                A complete DevOps platform for Zero-Knowledge Proof systems
            </p>
        </div>
        <div className="columns is-multiline">
          {features.map((feature, index) => (
            <div key={`feature-${index}`} className="column is-one-third">
              <div className="card card-hover">
                <div className="card-content">
                  <div className="media">
                    <div className="media-left">
                      <figure className="icon feature-icon p-6">
                        <i className={`fas  fa-lg fa-${feature.icon}`}></i>
                      </figure>
                    </div>
                    <div className="media-content">
                      <p className="is-4 mb-2">{feature.title}</p>
                      <p className="has-text-text-60">{feature.description} </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}


